const testData = [
    {
        user_ID: 1,
        username: 'LambdaSchool',
        email: 'student@lambdaschool.com',
        password: 'lambda',
        avatar: 'LambdaSchool.jpg',
        stories: [
            {
                storyID: 1,
                date: 'Jan 8, 2019',
                desc: 'Austen Allred, 29, grew up in Utah and served as a Mormon missionary in Ukraine before starting college at Brigham Young University in Provo.',
                file: '01-austen.jpg'
            },
            {
                storyID: 2,
                date: 'Aug 2, 2019',
                desc: 'When we started Lambda School just over two years ago the school didn’t look very different from every other code bootcamp. The only thing that separated us was how quickly we iterated and how intently we listened to feedback. Based on the feedback, we decided to create a new model of education: entirely online but live and interactive, no upfront tuition, and no payment at all until a student receives a job that pays $50k/yr or more. We would create an educational model where the incentives of the school were completely aligned with the incentives of the students, and where the school would only become successful if the students were. Demand for Lambda School exploded, and has only sped up since that day.',
                file: '02-lambda-feedback.jpg'
            },
            {
                storyID: 3,
                date: 'March 20, 2020',
                desc: 'I’m reaching out personally because it’s important to me that I reiterate that we’re committed to supporting you through this difficult time. I know the past few weeks have felt strange and uncertain for all of us, including myself. The unusual situation we find ourselves in now makes me that much more grateful for the incredible community at the heart of Lambda School. You are that community. You make this school what it is. Effective learning and job placement is still of the utmost importance, but none of those efforts would be nearly as successful without the connections, friendships, and support the Lambda School community thrives on. It’s one of the parts of Lambda School I’m most proud of. Now more than ever, it’s important we all connect with each other and put empathy first. ',
                file: '03-covid.jpg'
            },
            {
                storyID: 4,
                date: 'May 8, 2020',
                desc: 'As one of the highest paying and fastest-growing US industries, the tech sector represents a pathway to helping more women secure financial independence and security for themselves and their families. As a woman, a mother, and a tech executive, I know both from my personal and professional journeys that we need to do a better job of both supporting mothers in their careers and their family lives and making it easier for them to enter the industry. That’s why I’m so excited to announce that Lambda School has partnered with The Mom Project with the goal of helping more mothers and caregivers re-enter the workforce, re-skill, or break into tech.',
                file: '04-mom-project.jpg'
            },
        ]
    },
    {
        user_ID: 2,
        username: 'VishSingh',
        email: 'vishalicious213@gmail.com',
        password: 'sojourn',
        avatar: 'VishSingh.jpg',
        stories: [
            {
                storyID: 1,
                date: 'May 23, 2020',
                desc: 'La Guardia airport. Last day in NY.',
                file: '01-leaving-ny.jpg'
            },
            {
                storyID: 2,
                date: 'May 23, 2020',
                desc: 'Kiddos at the airport in Ft. Worth, Texas',
                file: '02-ft-worth-texas.jpg'
            },
            {
                storyID: 3,
                date: 'May 23, 2020',
                desc: 'John Wayne Airport, Santa Ana, California',
                file: '03-california.jpg'
            },
        ]
    },
]

export default testData;